export const dateFormat = 'D.M.YYYY HH:mm';
